import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _skyDevices;

import { CPUCapability, DEFAULT_DEVICE } from './models';
export var ModelNumber = {
  ES130: 'ES130',
  ES140: 'ES140',
  EM150: 'EM150',
  ES240: 'ES240',
  ES340: 'ES340',
  ES160: 'ES160',
  XiOne: 'XiOne',
  Llama: 'Llama'
}; // Chrome 58 has cssVariables

var cssVariables = true;
export var skyDevices = (_skyDevices = {}, _defineProperty(_skyDevices, ModelNumber.ES130, {
  friendlyName: 'X-wing v1',
  capabilities: {
    cpu: CPUCapability.Low,
    cssVariables: cssVariables
  },
  platform: 'sky_tv'
}), _defineProperty(_skyDevices, ModelNumber.ES140, {
  friendlyName: 'Falcon D1(v1)',
  capabilities: {
    cpu: CPUCapability.Low,
    cssVariables: cssVariables
  },
  platform: 'sky_tv'
}), _defineProperty(_skyDevices, ModelNumber.EM150, {
  friendlyName: 'Multiroom v1',
  capabilities: {
    cpu: CPUCapability.Low,
    cssVariables: cssVariables
  },
  platform: 'sky_tv'
}), _defineProperty(_skyDevices, ModelNumber.ES240, {
  friendlyName: 'Falcon v2 UK',
  capabilities: {
    cpu: CPUCapability.High,
    cssVariables: cssVariables
  },
  platform: 'sky_tv'
}), _defineProperty(_skyDevices, ModelNumber.ES340, {
  friendlyName: 'Titan',
  capabilities: {
    cpu: CPUCapability.High,
    cssVariables: cssVariables
  },
  platform: 'sky_tv'
}), _defineProperty(_skyDevices, ModelNumber.ES160, {
  friendlyName: 'Amidala',
  capabilities: {
    cpu: CPUCapability.Low,
    cssVariables: cssVariables
  },
  platform: 'sky_tv'
}), _defineProperty(_skyDevices, ModelNumber.XiOne, {
  friendlyName: 'Puck',
  capabilities: {
    cpu: CPUCapability.Low,
    cssVariables: cssVariables
  },
  platform: 'sky_tv'
}), _defineProperty(_skyDevices, ModelNumber.Llama, {
  friendlyName: 'Glass',
  capabilities: {
    cpu: CPUCapability.High,
    cssVariables: cssVariables
  },
  platform: 'sky_tv'
}), _skyDevices);
export var getSkyDevice = function getSkyDevice() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  var modelNumber = Object.keys(ModelNumber).find(function (d) {
    return userAgent.includes(d);
  });

  if (modelNumber !== undefined) {
    return skyDevices[modelNumber];
  }

  return DEFAULT_DEVICE;
};